import { bindEvents, clamp, getRootOffsetBounds, mq } from '../../../assets/js/helpers';

import AnimationController from '../../../assets/js/controller/animation';
import ResizeController from '../../../assets/js/controller/resize';
import ScrollController from '../../../assets/js/controller/scroll';

const selector = 'text-parallax';

export default class TextParallax {

	constructor(section) {
		this.el = {
			section
		};

		// class variable groups

		this.config = {
			maxShift: 80
		};

		this.controllers = {
			animation: null,
			resize: null,
			scroll: null
		};

		this.coords = {
			section: null
		};

		this.flags = {
			isScrolled: false
		};

		this.states = {
			lastShiftY: 0,
			ambientDirection: 0,
			scrollDelta: 0,
			speed: 0
		};

		// bind events to class scope
		this.events = bindEvents(this);

		// let's mosey
		this.init();
	}

	static get selector() {
		return selector;
	}

	// initialize

	init() {
		this.addEventListeners();
	}

	// event listeners

	addEventListeners() {
		this.controllers.resize = ResizeController.set({
			update: () => { this.events._onWindowResize(); },
			resize: () => {}
		});

		if (mq('medium')) {
			this.measureResize();
		}
	}

	removeEventListeners() {
		ResizeController.clear(this.controllers.resize);
		this.removeScrollListener();
	}

	// listener methods

	_onWindowResize() {
		this.measureResize();
	}

	measureResize() {
		if (mq('medium')) {
			this.coords.section = getRootOffsetBounds(this.el.section);
			this.addScrollListener();
		} else {
			this.removeScrollListener();
		}
	}

	//

	addScrollListener() {
		if (!this.controllers.animation) {
			this.controllers.animation = AnimationController.set({
				update: () => true,
				render: () => {

					const centerRatio = clamp((ScrollController.position + window.innerHeight / 2) / this.coords.section.centerY - 1, -1, 1);
					const shiftY = centerRatio * this.config.maxShift;

					this.el.section.style.transform = `translateY(${shiftY}px)`;

					this.flags.isScrolled = false;
				}
			});
		}

		if (!this.controllers.scroll) {
			this.controllers.scroll = ScrollController.set({
				update: (e) => {
					this.states.scrollDelta = e.delta;
					this.states.direction = e.direction;
					this.flags.isScrolled = true;

					if (this.states.direction) {
						this.states.ambientDirection = this.states.direction;
					}
				},
				render: () => {}
			});
		}
	}

	removeScrollListener() {
		if (this.controllers.animation) {
			AnimationController.clear(this.controllers.animation);
			this.controllers.animation = null;
		}

		if (this.controllers.scroll) {
			ScrollController.clear(this.controllers.scroll);
			this.controllers.scroll = null;
		}
	}

	// destroy

	destroy() {
		this.removeEventListeners();
	}

}
